import { cellRenderParseData } from '../../utils/functions';

/** Список полей */
const columnDataTN = [
  {
    dataField: 'ttn',
    caption: '№ ТН',
    dataType: 'string'
  },
  {
    dataField: 'ttnDate',
    caption: 'Дата ТН',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'vehicleIdOut',
    caption: '№ ТС отгруженного с УС',
    dataType: 'string'
  }
];

export default columnDataTN;
